import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import { MaeCard, MaePageHead, MaeShell } from '@/shared/desktop/MaeShell';
import { McpConnections } from '@/features/mcp/McpConnections';
import { useMcpAccess } from '@/features/mcp/useMcpAccess';

/**
 * `/admin/mcp-connections` — gli assistenti AI collegati da tutta l'azienda, con la revoca
 * (`docs/FE-TO-BE-MCP-v1.md` §3). Per chi ha `mcp.manage` o è super-admin.
 */
export const Route = createFileRoute('/_app/admin/mcp-connections')({ component: McpConnectionsAdminPage });

function McpConnectionsAdminPage() {
  const access = useMcpAccess();
  return (
    <MaeShell>
      <MaePageHead
        title="Assistenti AI collegati"
        sub="Chi ha collegato Claude a MaeWay in questa azienda, con quali permessi, e da qui si revoca."
        icon={<IconRobot size={23} />}
      />
      <Stack gap="md">
        {!access.moduleOn ? (
          <Alert color="gray" title="Assistenti AI non attivi per questa azienda">
            Il collegamento di assistenti è il modulo «Assistenti AI (MCP)», che attiva la piattaforma: lo stato si legge
            in «Moduli attivi». Finché è spento, nessuno può collegarne uno.
          </Alert>
        ) : !access.canManage ? (
          <Alert color="gray" title="Pagina riservata">
            Vedere e revocare i collegamenti degli altri richiede il permesso «mcp.manage». I tuoi li trovi in
            Impostazioni › Integrazioni.
          </Alert>
        ) : (
          <MaeCard>
            <McpConnections scope="tenant" />
          </MaeCard>
        )}
      </Stack>
    </MaeShell>
  );
}
